export default "__VITE_ASSET__DjiFQ4$D__"